export enum TimeReference {
  DAY = "DAY",
  HOUR = "HOUR",
  WEEK = "WEEK",
  MONTH = "MONTH"
}